import apiService from '../../services/api';

// Init state
const state = {
    items: [],
    item: {}
};

// Getters
const getters = {
    items: state => state.items
};

// Actions
const actions = {
    getListTree: (context, params) => {
        return apiService.get('mapLayer.tree', params).then(response => {
            context.commit('GET_LIST_SUCCESS', response);
            return response;
        });
    },
    getListLayer: (context, params) => {
        return apiService.get('mapLayer.index', params);
    },
    createLayer: (context, params) => {
        return apiService.post('mapLayer.index', params);
    },
    updateLayer: (context, params) => {
        return apiService.put('mapLayer.detail', params);
    },
    deleteLayer: (context, params) => {
        return apiService.delete('mapLayer.detail', params).then(response => {
            context.commit('DELETE_BY_ID_SUCCESS', params);
        });
    },
    uploadFile: (context, params) => {
        return apiService.postForm('mapLayer.file', params).then(response => {
            context.commit('UPDATE_SUCCESS', response);
        });
    },
    downloadFile: (context, params) => {
        return apiService.get('mapLayer.downloadFile', params);
    },
    deleteFile: (context, params) => {
        return apiService.delete('mapLayer.file', params);
    },
    getListFile: (context, params) => {
        return apiService.get('mapLayer.file', params);
    },
    getPointDetail: (context, params) => {
        return apiService.get('mapLayer.pointDetail', params);
    }
};

// Mutation
const mutations = {
    GET_LIST_SUCCESS: (state, response) => {
        state.items = response;
    },
    GET_INFO_SUCCESS: (state, response) => {
        state.item = response;
    },
    DELETE_BY_ID_SUCCESS: (state, response) => {
        function findConfigIndex(element) {
            return element.id === response.id;
        }
        const index = state.items.findIndex(findConfigIndex);
        state.items.splice(index, 1);
    },
    CREATE_SUCCESS: (state, response) => {
        state.items.push(response);
    },
    UPDATE_SUCCESS: (state, response) => {
        function findConfigIndex(element) {
            return element.id === response.id;
        }
        const index = state.items.findIndex(findConfigIndex);
        state.items.splice(index, 1, response);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
